// extracted by mini-css-extract-plugin
export default {"actionText":"shared_actionText__krnq6"};